// extracted by mini-css-extract-plugin
module.exports = {"box":"Page2_box__ZzsAc","boxTitle":"Page2_boxTitle__1MIAV","boxsubTitle":"Page2_boxsubTitle__2FNA2","labelText":"Page2_labelText__2VoYt"};